<template>
  <main class="spinner_cont_page column main__">
    <img class="row success" src="@/assets/success.svg" alt="success">

    <div class="row">

      <h1 v-if="$route.params.id === 'bv' || $route.params.id === 'ph' || $route.query.y === 'bv' || $route.query.y === 'ph'">Thanks for your rating ({{ countdownValue }})</h1>
      <h1 v-else>Thanks for your feedback </h1>
    </div>

    <p class="subtitle">
      Your feedback has been submitted successfully.
    </p>

    <!-- <button class="column flex_center btnn" @click="lets_go">
      OK
    </button> -->
  </main>
</template>
<script>
export default {
  name: "ThanksForRating",
  data() {
    return {
      countdownValue: 5
    };
  },

  methods: {
    lets_go() {
      // SPA-safe navigation
      this.$router.replace({ name: "home" });
    },
    // add 5s countdown to redirect to home page
    countdown() {
      const interval = setInterval(() => {
        this.countdownValue--;
        if (this.countdownValue <= 0) {
          clearInterval(interval);


            // path: '/ratting/:id',
            // name: 'ratting_front_client',
            // component: RattingFrontClient
            // console.log(this.$route.query.y);

          if (this.$route.params.id === 'bv') {
            //just refresh the page to the same route with the same params
            window.location.reload();
          } else if (this.$route.params.id === 'ph') {
            window.location.reload();
          } else if (this.$route.query.y === 'bv') {
            //go to bv ratting page
            window.location.href = this.$router.resolve({
              name: 'ratting_front_client',
              params: { id: 'bv' }
            }).href;
          } else if (this.$route.query.y === 'ph') {
            //go to ph ratting page
            window.location.href = this.$router.resolve({
              name: 'ratting_front_client',
              params: { id: 'ph' }
            }).href;
            
          }else {
            console.log('hi from sent link');
          }
        }
      }, 1000);
    }
  },
  mounted() {
    this.countdown();
  }
};
</script>
<style scoped>
.main__ {
  z-index: 100;
}

.spinner_cont_page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  text-align: center;
}

img {
  margin-bottom: 10px;
  width: 25%;
}

h1 {
  font-size: 26px;
}

.subtitle {
  font-size: 20px;
  color: #515151;
  margin-bottom: 15px;
}

button {
  background-color: #317BEB;
  border: 0;
  padding: 10px 40px;
  color: #F2F2F2;
  font-size: 18px;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 500;
  border-radius: 3px;
  cursor: pointer;
  align-self: end;
}

.success {
  max-width: 175px;
}

@media (max-width: 500px) {
  h1 {
    font-size: 22px;
  }
}
</style>
